// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  backend_url: 'https://7oqmb9k329.execute-api.ap-south-1.amazonaws.com/qa',
  baseUrl: 'https://lunch.itonicsit.de',
  appSync: {
    graphqlEndpoint: 'https://yjfhaanydzafdfwtpuqlnpwmce.appsync-api.ap-south-1.amazonaws.com/graphql',
    region: 'ap-south-1',
    authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    apiKey: 'null'
  },
  cognito: {
    userPoolId: 'ap-south-1_VgtT2ON6t',
    clientId: '7orqga7q2oj2mg4g866h1pp0on',
    webDomain: 'https://ktm-lunch.auth.ap-south-1.amazoncognito.com'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts